export enum AlertType {
    PARTY = 'PARTY',
    GUEST = 'GUEST'
}